<template>
  <div data-grm-comp="UrlShareTable">
    <div class="h-full flex-col hidden lg:flex">
      <table class="url-share-table">
        <colgroup>
          <col class="col-a">
          <col class="col-b">
          <col class="col-c">
          <col class="col-d">
          <col class="col-e">
        </colgroup>
        <thead class="h-8 bg-gray-200">
        <tr>
          <th>{{ $t("common.number") }}</th>
          <th>{{ $t("setting.name.title") }}</th>
          <th>{{ $t("link.path") }}</th>
          <th>{{ $t("link.regDate") }}</th>
          <th></th>
        </tr>
        </thead>
      </table>
      <div class="max-h-full overflow-y-auto scrollbar-hidden">
        <table class="url-share-table">
          <colgroup>
              <col class="col-a">
              <col class="col-b">
              <col class="col-c">
              <col class="col-d">
              <col class="col-e">
          </colgroup>
          <tbody>
            <template>
              <tr v-for="(urlShare, i) in urlShareDataList"
                  :key="urlShare.urlIdx"
                  class="cursor-pointer transition hover:bg-gray-100"
              >
                  <td>{{ urlShareNum(urlShare, i) }}</td>
                <td>
                  <template v-if="isEdit(urlShare)">
                    <GrmTextField v-model="urlShare.urlTitle"
                                  ref="urlTitle"
                                  size="xs"
                                  textalign="center"
                                  @keydown.esc="onCancelURLShare($event, urlShare)"
                                  @keydown.enter="onCreateURLShare($event, urlShare)"
                    />

                  </template>
                  <template v-else>{{urlShare.urlTitle}}</template>
                </td>
                <td>
                  <template v-if="isEdit(urlShare)">
                    <GrmTextField v-model="urlShare.urlPath"
                                  ref="urlPath"
                                  size="xs"
                                  textalign="center"
                                  @keydown.esc="onCancelURLShare($event, urlShare)"
                                  @keydown.enter="onCreateURLShare($event, urlShare)"
                    />

                  </template>
                  <template v-else >
                    <div @click="onStartURLShare($event, urlShare)">{{urlShare.urlPath}}</div>
                  </template>
                </td>
                <td>{{ urlShare.uptDate ?? '-' }}</td>
                <td>
                  <div v-if="isEdit(urlShare)" class="w-full flex justify-center gap-x-1">
                    <GrmBtn size="xs" @click="onCreateURLShare($event, urlShare)">{{ $t("common.register") }}</GrmBtn>
                    <GrmBtn size="xs" color="red" @click="onCancelURLShare($event, urlShare)">{{ $t("common.cancel") }}</GrmBtn>
                  </div>
                  <div v-if="!isEdit(urlShare) && ((me.userId === urlShare.regUserId) || hasEmceeRole())" class="w-full flex gap-x-1">
                    <GrmBtn class="flex-1" size="sm" @click="onUpdateURLShare($event, urlShare)">{{ $t("common.edit") }}</GrmBtn>
                    <GrmBtn class="flex-1" size="sm" color="red" @click="onRemoveURLShare($event, urlShare)">{{ $t("common.delete") }}</GrmBtn>
                  </div>
                </td>
              </tr>
              <tr v-if="!urlShareDataList.length">
                <td colspan="5" class="text-center">{{ $t("link.share.notExist") }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex flex-col gap-2 lg:hidden">
      <div v-for="(urlShare, i) in urlShareDataList"
           :key="urlShare.urlIdx"
           class="p-2 rounded bg-gray-100"
      >
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("common.number") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ isEdit(urlShare) ? (urlShare.urlIdx ? i + 1 : '-') : i + 1}}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("setting.name.title") }}</div>
          <div class="min-w-0 flex-1 py-1 px-3 text-sm lg:py-2">
            <template v-if="isEdit(urlShare)">
              <GrmTextField v-model="urlShare.urlTitle"
                            ref="urlTitle"
                            size="xs"
                            @keydown.esc="onCancelURLShare($event, urlShare)"
                            @keydown.enter="onCreateURLShare($event, urlShare)"
              />
            </template>
            <template v-else>{{ urlShare.urlTitle }}</template>
          </div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("link.path") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm" >
              <template v-if="isEdit(urlShare)">
                  <GrmTextField v-model="urlShare.urlPath"
                                ref="urlpath"
                                size="xs"
                                @keydown.esc="onCancelURLShare($event, urlShare)"
                                @keydown.enter="onCreateURLShare($event, urlShare)"
                  />
              </template>
              <template v-else>
                <div @click="onStartURLShare($event, urlShare)">{{ urlShare.urlPath ?? '-' }}</div>
              </template>
          </div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("link.regDate") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ urlShare.uptDate ?? '-' }}</div>
        </div>
        <div class="py-2 px-3 flex justify-center">
          <div v-if="isEdit(urlShare)" class="w-full flex justify-center gap-x-1">
            <GrmBtn class="flex-1" size="sm" @click="onCreateURLShare($event, urlShare)">{{ $t("common.register") }}</GrmBtn>
            <GrmBtn class="flex-1" size="sm" color="red" @click="onCancelURLShare($event, urlShare)">{{ $t("common.cancel") }}</GrmBtn>
          </div>
          <div v-if="!isEdit(urlShare) && ((me.userId === urlShare.regUserId) || hasEmceeRole())" class="w-full flex gap-x-1">
            <GrmBtn class="flex-1" size="sm" @click="onUpdateURLShare($event, urlShare)">{{ $t("common.edit") }}</GrmBtn>
            <GrmBtn class="flex-1" size="sm" color="red" @click="onRemoveURLShare($event, urlShare)">{{ $t("common.delete") }}</GrmBtn>
          </div>
        </div>
      </div>
      <div v-if="!urlShareDataList.length">
          <p class="text-center p-2 rounded bg-gray-100 text-sm">{{ $t("link.share.notExist") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";

export default {
  name: "UrlShareTable",
  components: {
    GrmBtn,
    GrmTextField
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('urlShare', [
      'urlShareList',
    ]),
    ...mapGetters('user', [
      'me',
      'hasEmceeRole',
    ]),

    urlShareDataList(){
      return _.cloneDeep(this.urlShareList)
    },

    isEdit() {
      return (urlShare) => urlShare.type === 'edit';
    },

    urlShareNum() {
      return (item, idx) => {
        if (this.isEdit(item)) {
          if(!item.urlIdx) {
              return '-';
          }
        }
        return this.urlShareDataList.length - idx;
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('urlShare', [
      'createOrUpdateURLShare',
      'removeURLShare',
      'getURLShareList',
      'startURLShareList',
    ]),
    ...mapMutations('urlShare', [
      'ADD_URLSHARE_EDIT_STATE',
      'REMOVE_URLSHARE_EDIT_STATE'
    ]),

    async onCreateURLShare(e, urlShare) {
      e.stopPropagation();

      if (!this.validateCreate(urlShare)) {
        return;
      }

      const THIS = this;
      await this.createOrUpdateURLShare(urlShare)
          .then(() => {
            THIS.$alert({
              text: this.$t('link.success'),
              onlyOk: true
            });
          })
          .catch(e => {
            THIS.$alert({
              text: this.$t('link.fail', { '0' : e.message}),
              onlyOk: true
            });
            console.error('register fail urlShare data', e);
          });
    },
    onCancelURLShare(e, urlShare) {
      e.stopPropagation();
      this.REMOVE_URLSHARE_EDIT_STATE(urlShare);
    },
    onStartURLShare(e, urlShare) {
      e.stopPropagation();

      if (!this.hasEmceeRole()) {
        return;
      }

      this.$alert({
        text : this.$t('link.confirm'),
        ok: () => {
          this.startURLShareList(urlShare);

          const width = Math.min('1280', screen.width);
          const height = Math.min('720', screen.height);
          window.open(urlShare.urlPath, `url_share_${urlShare.urlIdx}`, `width=${width},height=${height}`)
        },
      });

    },
    async onRemoveURLShare(e, urlShare) {
      if (this.me.userId === urlShare.regUserId || this.hasEmceeRole()) {
        if (urlShare.urlIdx === 0) {
          this.$alert({
            text: this.$t('link.notExist'),
            onlyOk: true
          });
          return;
        }

        const THIS = this;
        await this.removeURLShare(urlShare)
            .then(() => {
              THIS.$alert({
                text: this.$t('link.deleted'),
                onlyOk: true
              });
            })
            .catch(e => {
              this.$alert({
                text: this.$t('link.cannotFind'),
                onlyOk: true
              });
              console.error('remove fail urlShare data', e);
            });
      }
    },
    async onUpdateURLShare(e, urlShare) {
      e.stopPropagation();
      const idx = this.urlShareDataList.findIndex(item => item.urlIdx === urlShare.urlIdx);
      if (idx > -1) {
          Vue.set(this.urlShareDataList[idx], 'type', 'edit')
          this.ADD_URLSHARE_EDIT_STATE(urlShare);
      }
    },
    validateCreate(urlShare) {
      if (!urlShare.urlTitle.trim()) {
        this.$alert({
          text: this.$t('link.enterTitle'),
          onlyOk: true
        });
        return false;
      }
      // eslint-disable-next-line
      const urlRegExp = new RegExp(/(http(s)?:\/\/|www.)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}([\/a-z0-9-%#?&=\w])+(\.[a-z0-9]{2,4}(\?[\/a-z0-9-%#?&=\w]+)*)*/gi);
      if (!urlShare.urlPath || !urlRegExp.test(urlShare.urlPath)) {
        this.$alert({
          text: this.$t('link.valid'),
          onlyOk: true
        });
        return false;
      }
      return true;
    },
  }
}
</script>

<style lang="scss" scoped>
.url-share-table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  colgroup {
    .col-a {
      width: 2%;
    }
    .col-b {
      width: 6%;
    }
    .col-c {
      width: 12%;
    }
    .col-d {
      width: 4%;
    }
    .col-e {
      width: 6%;
    }
  }
}
tr {
  @apply h-10 border-b border-gray-100 whitespace-nowrap;
}
th {
  @apply px-3 text-xs whitespace-nowrap
}
td {
  @apply px-3 text-xs truncate whitespace-nowrap
}
</style>